import { createUseStyles } from 'react-jss'
import { darkGrey, mediumGrey } from '../../../../styles/const/colors'

const useStyles = createUseStyles({
  // APP CRASH styles should avoid using THEME styles
  // in case when the app crashes theme will be undefined and instead of representing fallback crash screen will just crash here again
  infoContainer: {
    textAlign: 'center',
    marginTop: 150,
    marginRight: 'auto',
    marginLeft: 'auto'
  },
  title: {
    color: darkGrey,
    fontSize: 24,
    marginTop: 24,
    marginBottom: 16,
    lineHeight: 0.885
  },
  description: {
    color: mediumGrey,
    fontSize: 16,
    lineHeight: 1.1
  }
})

export default useStyles
